<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <dashboard-ctrl :componentName="componentName"
                            :showHideButton="showHideButton"
                            :showPinButton="showPinButton"
                            :showResizeIcon="showResizeIcon"
                            :isDynamicRegister="true"
                            :size="size"
                            :headerTitle="titleKey"
                            :componentClass="'card-header bg-primary text-white'"
                            :showHeadful="showHeadful"
                            @hide="hide"
                            @resize="resize"
                            @pinned="pinned"
                            @unpinned="unpinned">
            </dashboard-ctrl>

            <div class="card-header" v-if="showNewButton || showSettingsBtn">
                <button type="button" class="btn btn-info btn-sm"
                        v-if="showNewButton"
                        @click="createBtnClick">
                    {{$t('buttons.create.btnText')}}
                </button>

                <button type="button" class="btn btn-info btn-sm"
                        @click="goToExportTemplate"
                        v-if="isEventRegister && showImportFromExcelButton"
                        v-bind:disabled="participantsExporting">
                    <i v-if="participantsExporting" class="fa fa-spinner fa-pulse fa-fw"></i>
                    {{$t('buttons.exportTemplate.btnText')}}
                </button>

                <button type="button" class="btn btn-info btn-sm"
                        @click="selectImportFiles"
                        v-bind:disabled="participantsImporting"
                        v-if="isEventRegister && showImportFromExcelButton">
                    <i v-if="participantsImporting" class="fa fa-spinner fa-pulse fa-fw"></i>
                    {{$t('buttons.importFromExcel.btnText')}}
                </button>
                <input type="file"
                       id="importFile"
                       class="selectFile"
                       v-if="isEventRegister && showImportFromExcelButton"
                       @change="goToImportFromExcel" />

                <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings ref="userSettings"
                                    :schemaModelFields="schemaModel.fields"
                                    :componentName="componentName"
                                    :useLabelAsTitle="true"
                                    :showUserSettings="true"
                                    :gridOptions="userSettings"
                                    v-if="showUserSettingsForm"
                                    @saveGridSettings="saveGridSettings"
                                    @loadGridSettings="loadGridSettings"
                                    @userSettingsChanged="userSettingsChanged">
                </grid-user-settings>
            </div>



            <!--<div class="header form-control" v-cloak>
                <div class="input-group col-sm-3 float-right">
                    <div class="input-group-addon fa fa-search" style="display:table-cell"></div>
                    <input class="form-control fa fa-search" name="query" v-model="searchQuery">
                    <button @click="massSearch">Search</button>
                    <button @click="clearFilter">Clear</button>
                </div>
            </div>-->
            <!--:schema-total="'count'"
            :schema-data="'items'"-->

            <div class="card-body" id="grid_card">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="schemaModel.id"
                                  :schema-model-fields="schemaModel.fields"
                                  :schema-data="'data'"
                                  :schema-total="'total'"
                                  :schema-aggregates="'aggregates'"
                                  :schema-groups="'groups'"
                                  :schema-errors="'errors'"
                                  :page-size='gridOptions.pageable.size'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"
                                  :requestStart="datasorceRequestStart">
                </kendo-datasource>

                <kendo-grid ref="grid" id="grid1"
                            :data-source-ref="'datasource1'"
                            :columns="columns"
                            :pageable="gridOptions.pageable"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="gridOptions.toolbar"
                            :excel="gridOptions.excel"
                            :pdf="gridOptions.pdf"
                            :dataBound="dataBound">
                    <kendo-contextmenu @select="selectContextMenu" :target="'#grid1'" :filter="'td'">
                        <li :id="'edit'" class="text-success"><i class="fas fa-edit"></i> {{ $t('buttons.edit.btnText') }}</li>
                        <li :id="'details'" class="text-info"><i class="fas fa-eye"></i> {{ $t('buttons.details.btnText') }}</li>
                        <li :id="'delete'" class="text-danger"><i class="far fa-trash-alt"></i> {{ $t('buttons.delete.btnText') }}</li>
                        <li :id="'pdf'" class="text-danger"><i class="far fa-file-pdf"></i> {{ $t('buttons.pdfExport.btnText') }}</li>
                        <li :id="'excel'" class="text-success"><i class="far fa-file-excel"></i> {{ $t('buttons.excelExport.btnText') }}</li>
                        <li :id="'archive'" class="text-secondary"><i class="far fa-file-archive"> </i>{{ $t('buttons.archive.btnText') }}</li>
                    </kendo-contextmenu>
                </kendo-grid>
            </div>
        </div>
    </div>

</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from "../../../components/grid/UserSettings";
    import { DynamicRegister } from '../../../models/enums';
    import ControlBtnsTemplate from "../../../components/dashboard/ControlBtnsTemplate";
    import SearchInputTemplate from "../../../components/grid/SearchInputTemplate";
    import { mapGetters } from 'vuex'

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */

    //kendo.pdf.defineFont({
    //    "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
    //    "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
    //    "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
    //    "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
    //    "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    //});

    export default {
        name: 'dynamic-data-grid',
        components: {
            'dashboard-ctrl': ControlBtnsTemplate,
            'grid-user-settings': GridUserSettings,
        },
        created: function () {
            if (this.showBtns) {
                return;

                //Skip for now. ContextMenu has been implemented
                let hasCommandBtns = false;
                for (var i = 0; i < this.columns.length; i++) {
                    let col = this.columns[i];
                    if (col.hasOwnProperty('field') && col.field === 'btnsCellTemplate') {
                        hasCommandBtns = true;
                    }
                }

                if (hasCommandBtns === false) {
                    this.columns.push({
                        field: 'btnsCellTemplate', // ����� �� ������ �� ���������� �� ��������������� �������� � ������������ �� ���������
                        title: ' ',
                        editable: false,
                        reorderable: false,
                        resizable: false,
                        filterable: false,
                        sortable: false,
                        lockable: true,
                        locked: false,
                        groupable: {
                            enabled: false
                        },
                        width: 300,
                        command: [
                            {
                                name: 'edit',
                                text: ' ', //this.$t('buttons.edit.btnText'),
                                click: this.cellCommandClick,
                                iconClass: 'btn btn-success fas fa-edit'
                            },
                            {
                                name: 'details',
                                text: ' ', //this.$t('buttons.details.btnText'),
                                click: this.cellCommandClick,
                                iconClass: 'btn btn-info fas fa-eye'
                            },
                            {
                                name: 'delete',
                                text: ' ', // this.$t('buttons.delete.btnText'),
                                click: this.cellCommandClick,
                                iconClass: 'btn btn-danger far fa-trash-alt'
                            },
                            {
                                name: 'pdf',
                                text: ' ',  //this.$t('buttons.pdfExport.btnText'),
                                click: this.cellCommandClick,
                                iconClass: 'btn btn-danger far fa-file-pdf'
                            },
                            {
                                name: 'excel',
                                text: ' ',  //this.$t('buttons.excelExport.btnText'),
                                click: this.cellCommandClick,
                                iconClass: 'btn btn-success far fa-file-excel'
                            },
                            {
                                name: 'archive',
                                text: ' ',  //this.$t('buttons.archive.btnText'),
                                click: this.cellCommandClick,
                                iconClass: 'btn btn-secondary far fa-file-archive'
                            }
                        ]
                    });
                }

            }
            window.JSZip = JSZip // ���������� � �� �� ������ �������� � excel
        },
        props: {
            schemaModel: {
                id: {
                    default: '',
                    type: String
                },
                fields: {}
            },
            columns: {},
            registerName: {
                default: '',
                type: String
            },
            titleKey: {
                default: '',
                type: String
            },
            // ����������, ����� ������� �� ���������� � �������� �� ������� �����������
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: true,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            gridHeight: {
                default: 800,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showImportFromExcelButton: {
                default: false,
                type: Boolean
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                componentName: this.registerName, // ������ �� ������������ �� �������� �� ������� �����������
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                participantsImporting: false,
                participantsExporting: false,
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/dynamicRegisters/' + this.registerName,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json; charset=utf-8',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: [
                        //'excel',
                        //'pdf',
                        //{ template: this.searchInputTemplate }
                    ],
                    excel: {
                        fileName: this.registerName + '.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: this.registerName + '.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                showUserSettingsForm: false,
                searchQuery: ''
            }
        },
        methods: {
            searchInputTemplate: function (e) {
                return {
                    template: Vue.component(SearchInputTemplate.name, SearchInputTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,

                    }
                };
            },
            dataBound(e) {
                if (!this.customSettingsLoaded) {
                    this.customSettingsLoaded = true;
                    this.loadGridSettings();
                }
            },
            dataSourceError(e) {
                console.log(e.errors); // Your error information
                e.sender.cancelChanges();

                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // ������ POST action �� �������� �� �������������� � ������ �� �������������
                    // options. ���� �� ������� ���������� �� take, skip , page � ������ � ������
                    // �������� �����������

                    this.saveState();
                    return JSON.stringify(options);
                }
            },
            saveGridSettings() {
                let grid = this.$refs.grid.kendoWidget();

                if (grid) {
                    // ������� ������ ��������� �� ���������� � ��������������� ���������
                    this.$refs.userSettings.setGridSettings(grid.getOptions());
                }

                let options = grid.getOptions();
                // ��� ��������� �� �������� �� ���������� �������� � ListDynamicData.vue
                // ����� ��� �������� ������ � ������. ��� �� ������ �� � ���������.
                if (options.hasOwnProperty('columns')) {
                    for (var i = 0; i < options.columns.length; i++) {
                        let col = options.columns[i];
                        if (col.hasOwnProperty('field') && col.field === 'btnsCellTemplate') {
                            options.columns.splice(i, 1);
                        }
                    }
                }

                this.$http.post('/api/personalization/saveGridSettings', {
                    componentName: this.componentName,
                    gridSettings: JSON.stringify(options)
                }).then((response) => {
                    this.$vs.notify({
                        title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                        text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            loadGridSettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getGridSettings'
                ).then((response) => {
                    if (response.data.settings === null || !response.data.settings) {
                        // ������� �������� ������� � �� � ������������� ���������. ����� ���� �� ������������

                        return;
                    }

                    try {
                        let options = JSON.parse(response.data.settings); // ������������� ����������� �������� � ������, ��� ��� ������
                        if (!options || !options.hasOwnProperty("columns")) {
                            // ������� ������� ���������
                            return;
                        }

                        for (var i = 0; i < this.columns.length; i++) {
                            // ��� �� ����� ��������� �������� � �������� ������ (�������� �� ����� ��������� �������� ����� �� this.columns),
                            // �� ������ � ��������������� ��������� (��� ��� �������� ������).
                            // T����� �� �� ������ ��� ��������������� ��������, ����� ������ �� �������.

                            let col = this.columns[i];

                            let exists = false;
                            for (var j = 0; j < options.columns.length; j++) {
                                let userSettingsCol = options.columns[j];
                                if (col.field && userSettingsCol.field && col.field === userSettingsCol.field) {
                                    exists = true;
                                    break;
                                }
                            }

                            if (!exists) {
                                options.columns.push(col);
                            }
                        }


                        // � ���������� �� ����-� �������� �� ����� ���������� ��� ������, ����� �� ��������� � ���������� �����.
                        // View-��, ����� ������� ������� ������ ���� ��������� ������. ����������� �� ���������� ����� ������ ������ �� �� ����������.

                        //for (var i = 0; i < options.columns.length; i++) {
                        //    // ��� �� ����� ��������� �������� � �������� ������ (�������� �� ����� ��������� �������� ����� �� this.columns),
                        //    // �� ������ � ��������������� ��������� (��� ��� �������� ������).
                        //    // T����� �� �� ������ ��� ��������������� ��������, ����� ������ �� �������.

                        //
                        //    let col = options.columns[i];

                        //    let exists = false;
                        //    for (var j = 0; j < this.columns.length; j++) {
                        //        let userSettingsCol = this.columns[j];
                        //        if (col.field && userSettingsCol.field && col.field === userSettingsCol.field) {
                        //            exists = true;
                        //            break;
                        //        }
                        //    }

                        //    if (!exists) {
                        //        options.columns = options.columns.slice(i,1);
                        //    }
                        //}



                        let grid = this.$refs.grid.kendoWidget();
                        if (grid) {
                            grid.setOptions(options);

                            if (options.pageable.size != grid.dataSource.options.pageSize) {
                                grid.dataSource.pageSize(options.pageable.size);
                                grid.refresh();
                            }

                            // ������� ������ ��������� �� ���������� � ��������������� ���������
                            this.$refs.userSettings.setGridSettings(grid.getOptions());
                        }

                        //this.$vs.notify({
                        //    title: '',
                        //    text: this.$t('personalSettingsLoaded'),
                        //    color: 'success',
                        //    time: this.$store.getters.notificationDuration,
                        //})
                    } catch (e) {

                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.grid.kendoWidget();

                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            grid.dataSource.pageSize(userSettings.pageable.size);
                            grid.refresh();
                        }
                    } catch (e) {
                        return;
                    }
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage['' + this.registerName + "registers-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["organizers-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            hasDeletionRights() {
                return true;
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            createBtnClick: function () {
                this.$router.push('/registers/' + this.registerName + '/create');
            },
            editBtnClick: function (args) {
                this.$router.push('/registers/' + this.registerName + '/edit/' + args.id);
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            resize(componentName, size) {
                this.$emit('resize', componentName, size, this.$refs.grid.kendoWidget())
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {
                    // 	console.log(e.response[0]);
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            datasorceRequestStart(e) {
                if (e.type == "read" && e.response) {
                    // 	console.log(e.response[0]);
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            cellCommandClick(ev) {
                let commandName = ev.data.commandName,
                    gridWidget = this.$refs.grid.kendoWidget(),
                    tr = $(ev.target).closest('tr'),
                    data = gridWidget.dataItem(tr);

                if (commandName === 'edit') {
                    // ��������
                    let url = '/registers/' + this.registerName + '/edit/' + data.id;
                    this.$router.push(url);
                } else if (commandName === 'details') {
                    console.log('Todo: details')
                    // ������� �� �������
                } else if (commandName === 'delete') {
                    if (this.hasDeletionRights) {


                        // ���������
                        this.delete(data.id);
                    }
                } else if (commandName === 'pdf') {
                    // ������� � pdf

                } else if (commandName === 'excel') {
                    // ������� � excel

                } else if (commandName === 'archive') {
                    // ������� �� ����� (JSON �� ������ �� �������)
                    if (this.isEventRegister) {
                        this.$emit("archive", DynamicRegister.Events, data.id, this.registerName.toLowerCase())
                    }
                }
            },
            delete(id, eventName) {
                kendo.confirm(`${this.$t('registers.events.confirmations.delete')} '${id}/${eventName}'?`)
                    .then(function () {
                        this.working = true;
                        this.$http.delete('/api/dynamicRegisterEntry/delete',
                            { params: { id: id } }
                        ).then((response) => {
                            this.$refs.grid.kendoWidget().dataSource.read();
                            this.$vs.notify({
                                title: this.$t('buttons.delete.action'),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration,
                            })
                        }).catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            })
                        })

                        this.working = false;
                    }.bind(this));
            },
            goToExportTemplate() {
                this.participantsExporting = true;

                this.$http.get('/api/dynamicRegisters/exportEventsTemplate/', {
                    parameters: {
                        registerEntityId: this.entryId,
                        withData: false
                    },
                    responseType: 'blob'
                })
                    .then(response => {
                        this.participantsExporting = false;

                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Events.xlsx'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    }).catch(error => {
                        this.participantsExporting = true;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            selectImportFiles() {
                var dialog = $("#importFile");
                dialog.trigger("click");
            },
            goToImportFromExcel(args) {
                var $input = $("#importFile")[0];
                var files = $input.files;
                if (files && files.length > 0) {
                    var filename = files[0].name;
                    var file = files[0];

                    // clear the selected file so that the change event triggers when the same file is selected
                    $input.value = null;

                    var formData = new FormData();
                    formData.append('FileName', filename);
                    formData.append('FileContent', file);

                    this.$http.post('/api/dynamicRegisters/import', formData).then(response => {
                        this.$refs.grid.kendoWidget().dataSource.read();

                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
                }
            },
            selectContextMenu(e) {
                var btnId = e.item.id;
                var index = e.target.parentElement.rowIndex;
                var row = this.$refs.grid.kendoWidget().dataSource.data()[index]
                var id = row.id;
                var colName = this.$store.getters.eventNameColumnName;
                var eventName = row[colName];

                if (btnId === 'edit') {
                    // ��������
                    let url = '/registers/' + this.registerName + '/edit/' + id;
                    this.$router.push(url);
                } else if (btnId === 'details') {
                    console.log('Todo: details')
                    // ������� �� �������
                } else if (btnId === 'delete') {
                    if (this.hasDeletionRights) {


                        // ���������
                        this.delete(id, eventName);
                    }
                } else if (btnId === 'pdf') {
                    this.$http.get('/api/DynamicRegisters/' + this.registerName + '/pdfExport/' + id, { responseType: 'blob' })
                        .then(response => {
                            ;
                            const blob = new Blob([response.data], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.registerName + '.pdf'); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                        }).catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        });


                } else if (btnId === 'excel') {
                    this.$http.get('/api/DynamicRegisters/' + this.registerName + '/excelExport/' + id, { responseType: 'blob' })
                        .then(response => {
                            ;
                            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.registerName + '.xlsx'); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                        }).catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        });



                } else if (btnId === 'archive') {
                    // ������� �� ����� (JSON �� ������ �� �������)
                    if (this.isEventRegister) {
                        this.$emit("archive", DynamicRegister.Events, id, this.registerName.toLowerCase())
                    }
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            clearFilter() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    this.searchQuery = '';
                    grid.dataSource.filter({});
                }
            },
        },
        mounted() {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.grid.kendoWidget();
                return grid.getOptions();
            },
            isEventRegister() {
                let regName = this.registerName.toLowerCase();
                return regName === 'events';
            }
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }

    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>
